export default __webpack_public_path__ + "static/media/about-us-desktop-img.be5a6aa1.png";